import {useState} from "react";
import {DText, FlexCenter, FlexEnd, FlexStart, Padding, Tooltip} from "../../styles/CommonStyles";
import { TInput, TradeInputBody } from "../../styles/TradeStyles";
import Text from "../../utils/Text";
import {useRunAfterUpdate} from "../../hooks/common/useRunAfterUpdate";
import {onInputValueChangeUtil} from "../../utils/useInputValueChange";



const TradeInput = ({
    value, onValueChange, prefix, suffix, isMarket = false, error, type
} = {}) => {

    const [showTooltip, setShowTooltip] = useState(false)
    const [active, setActive] = useState(false)
    const runAfterUpdate = useRunAfterUpdate()

    const onInputChange = (e) => {
        const value = onInputValueChangeUtil(e, runAfterUpdate)
        onValueChange(value)
    }

    return (
        <TradeInputBody
            active={active}
            hover={!isMarket}
            error={error?.show && error?.type === type}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <Padding padding="0 5px">
                <FlexCenter height="100%">
                    <FlexStart width="30%">
                        <DText><Text tid={prefix} /></DText>
                    </FlexStart>
                    {isMarket ?
                        <FlexEnd width="45%">
                            <DText fontSize="0.8rem">
                                <Text tid="market" />
                            </DText>
                        </FlexEnd>
                        :
                        <TInput
                            onChange={onInputChange}
                            value={value ? value : ""}
                            onFocus={() => setActive(true)}
                            onBlur={() => setActive(false)}
                        />
                    }
                    <FlexEnd width="25%">
                        <DText fontSize="0.8rem">{suffix.toUpperCase()}</DText>
                    </FlexEnd>
                </FlexCenter>
            </Padding>
            <Tooltip right="40px" top="-45px" show={error?.show && showTooltip && error?.type === type}>
                <Text tid={error?.message} />
            </Tooltip>
        </TradeInputBody>
    )
}


export default TradeInput;